import index from './alert'

export default index